import React, { memo } from 'react'
import { ICarrierCapacity } from 'apps/marketplace/store/contractLanes/types'
import { carrierCapacitySummary } from 'apps/marketplace/utils/helpers/rates'
import { TableRow, TableCell, TableBody } from 'transfix-ui'

interface ICapacityTableEntriesProps {
  offerLimits: ICarrierCapacity[]
}

export const CapacityTableEntries = memo<ICapacityTableEntriesProps>(({ offerLimits }) => (
  <TableBody>
    {offerLimits.map((offerLimit: ICarrierCapacity) => {
      const { createdBy, pickupLocation } = offerLimit || {}
      const { city, radius, stateCode } = pickupLocation || {}
      return (
        <TableRow key={offerLimit.id}>
          <TableCell>{`${city}, ${stateCode}`}</TableCell>
          <TableCell>{radius} mi</TableCell>
          <TableCell>{carrierCapacitySummary(offerLimit)}</TableCell>
          <TableCell>
            {createdBy ? `${createdBy.firstName} ${createdBy.lastName}` : 'Unknown'}
          </TableCell>
        </TableRow>
      )
    })}
    {offerLimits.length === 0 && (
      <TableRow>
        <TableCell>No Capacity</TableCell>
      </TableRow>
    )}
  </TableBody>
))
